import { AbiCoder } from "ethers";
export const abiEncode = (types, values) => AbiCoder.defaultAbiCoder().encode(types, values);
